// Notifications plugin. Used on Notifications page
import Notifications from '@core/app/components/farbcode-core/NotificationPlugin';

export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.vueApp.use(Notifications);

    return {
        provide: {
            notify: nuxtApp.vueApp.config.globalProperties.$notify
        }
    };
})